import OtpButton from 'components/otp-button/otp-button';

export default OtpButton;
